import type { FC } from 'react';
import { Box, Link, Typography } from '@material-ui/core';

const links = [
  {
    label: 'Terms & Conditions',
    href: '/terms'
  }
];

export const Footer: FC = () => {
  const year = new Date().getFullYear();
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          p: {
            md: 3,
            xs: 2
          }
        }}
      >
        <Typography
          color="textSecondary"
          variant="caption"
          sx={{
            fontSize: { xs: '10px', md: '12px' },
          }}
        >
          ©
          {' '}
          {year}
          {' '}
          Muskmelon Envtech Pvt. Ltd.
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        {links.map((link) => (
          <Link
            color="textSecondary"
            href={link.href}
            key={link.label}
            target="_blank"
            underline="none"
            variant="caption"
            sx={{
              fontSize: { xs: '10px', md: '12px' },
            }}
          >
            {link.label}
          </Link>
        ))}
      </Box>
    </div>
  );
};
